import { render, staticRenderFns } from "./SheetBlockAssociatedDocumentsSelectItem.vue?vue&type=template&id=60ac2756&scoped=true"
import script from "./SheetBlockAssociatedDocumentsSelectItem.vue?vue&type=script&lang=js"
export * from "./SheetBlockAssociatedDocumentsSelectItem.vue?vue&type=script&lang=js"
import style0 from "./SheetBlockAssociatedDocumentsSelectItem.vue?vue&type=style&index=0&id=60ac2756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ac2756",
  null
  
)

export default component.exports